import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var appMounted = createAction("".concat(actionKey, "/MOUNTED"), function () { return ({}); });
export var appUnmounted = createAction("".concat(actionKey, "/UNMOUNTED"), function () { return ({}); });
export var appVisibilityChange = createAction("".concat(actionKey, "/VISIBILITY"), function (hidden) { return ({ hidden: hidden }); });
//# sourceMappingURL=actions.js.map